import clsx from 'clsx'
import React, { ButtonHTMLAttributes, forwardRef, ReactNode } from 'react'

import styles from './index.module.scss'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string
  color?: 'dark' | 'primary' | 'white' | 'grey' | 'black'
  disabled?: boolean
  secondaryContent?: ReactNode
  size?: 'medium' | 'small'
  type?: 'submit' | 'reset' | 'button'
  variant?: 'full' | 'outlined'
  width?: 'full' | 'auto'
}

// This function helps us translate weird button inputs from the CMS to something tangible.
export const parseButtonColor = (buttonColor?: ButtonProps['color'] | 'default'): ButtonProps['color'] => (
  buttonColor === 'default'
    ? 'primary'
    : buttonColor || 'primary'
)

/**
 * @deprecated The Button in CoreComponents/Buttons/Button.tsx should not be used
 */
export const Button = forwardRef<HTMLButtonElement | null, ButtonProps>(({
  children,
  className,
  color = 'primary',
  disabled = false,
  secondaryContent,
  size = 'medium',
  type = 'button',
  variant = 'full',
  width = 'full',
  ...props
}, ref) => (
  <button
    className={clsx(
      styles.button,
      color && styles[color],
      size && styles[size],
      variant && styles[`variant${variant}`],
      width && styles[`width${width}`],
      !!secondaryContent && styles.secondary,
      className,
    )}
    disabled={disabled}
    ref={ref}
    // eslint-disable-next-line react/button-has-type
    type={type}
    {...props}
  >
    <span className={clsx(
      styles.buttonText,
      size === 'small' && styles.textSmall,
      !!secondaryContent && styles.buttonSpan,
    )}
    >
      {children}
    </span>
    {secondaryContent && <span className={styles.additionalContent}>{secondaryContent}</span>}
  </button>
))
